module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Se filmen:":"Watch the movie:","Så funkar Gritify":"How Gritify works"},"sv":{"Se filmen:":"Se filmen:","Så funkar Gritify":"Så funkar Gritify"}}')
  delete Component.options._Ctor
}
